import 'reflect-metadata';
import 'stencil-apollo';
import { setToken } from '../utilities/global';

setToken();

declare global {
  interface Number {
    formatPrice(): number;
  }
}

Number.prototype.formatPrice = function () {
  return this.toLocaleString('en-US', { style: 'currency', currency: 'USD' }).replace('.00', '');
};

export default function () {
  setToken();
}
